// Document ready
$(() => {
  window.utils.enableDisclosure();
  const oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    const that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener(
        "load",
        () => {
          that.onresize();
        },
        true
      );
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener("lazyloaded", (e) => {
    let bg = e.target.getAttribute("data-bg");
    const mobileBg = e.target.getAttribute("data-mobile-bg");
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  window.imageFunctions.flickityIosFix();

  window.objectFitImages();
  window.header.init();
  window.meganavManager.injectAll();
  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.searchAutocomplete.init();
  }
  window.utils.initializeSectionWrapper();
  window.slideshow.init();
  window.testimonials.init();
  window.video.init();
  window.gallery.init();
  window.videoFeature.setupVideoPlayer();
  window.featuredPromotions.init();
  window.featuredCollection.init();
  window.collectionSidebarFilter.init();
  window.cart.init();
  window.map.init();
  window.productPage.init();
  window.productPage.runOptionSelector();
  window.productPage.initializeQuantityBox();
  window.recentlyViewed.init();
  window.sidebarAccordions.init();

  if (
    window.PXUTheme.currency.show_multiple_currencies ||
    window.PXUTheme.currency.native_multi_currency
  ) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const { pathname } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith("/challenge")) {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      "slow"
    );
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener(
    "resize",
    () => {
      // If timer is null, reset it to 66ms and run your functions.
      // Otherwise, wait until timer is cleared
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
          // Reset timeout
          resizeTimeout = null;
          // Grab screen width after screen is resized
          const currentScreenWidth = $(window).width();
          // Run our resize functions
          if (
            window.PXUTheme.media_queries.medium.matches &&
            currentScreenWidth !== beforeResizeWidth
          ) {
            window.cart.init();
            if (!window.is_touch_device()) {
              window.header.unload();
              window.header.init();
            }
          }

          // swap lazysizes background mobile images when browser is resized
          const lazysizesBackgroundImages =
            document.querySelectorAll("[data-bg]");
          lazysizesBackgroundImages.forEach((image) => {
            let bg = image.getAttribute("data-bg");
            const mobileBg = image.getAttribute("data-mobile-bg");

            if (bg) {
              if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
                bg = mobileBg;
              }

              image.style.backgroundImage = `url(${bg})`;
            }
          });
        }, 66);
      }
    },
    false
  );

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = "fade";
  $.fancybox.defaults.transitionEffect = "fade";
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.arrows = true;
  $.fancybox.defaults.mobile.buttons = ["close"];
  $.fancybox.defaults.mobile.clickSlide = "close";
  $.fancybox.defaults.mobile.clickContent = "zoom";
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === "image") {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content
        .find(".fancybox-image-wrap")
        .append(
          `<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`
        );
    }
  };

  // backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  const $videoIframes = $(
    'iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]'
  );

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return "1:1";
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? "4:3" : "16:9";
  }

  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr("src");

    if (
      !$iframe.parents(".plyr__video-wrapper").length &&
      !$iframe.parents(".lazyframe").length
    ) {
      $iframe.wrap(
        `<div class="lazyframe" data-ratio="${getAspectRatio(
          $iframe.attr("width"),
          $iframe.attr("height")
        )}" data-src="${source}"></div>`
      );
    }
  });

  // Initiate lazyframe
  window.lazyframe(".lazyframe");

  // Wrap shopify policy in grid layout classes
  $(".shopify-policy__container").wrap(
    '<section class="section shopify-policy-template"><div class="container content"></div>'
  );

  // Add classes to determine column size
  $(".shopify-policy__container").addClass(
    "five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole"
  );

  // Add featured divider beneath page title
  $(".shopify-policy__title").append('<div class="feature_divider"></div>');

  // Search input hiding
  // get current input
  const currentValue = $(".search__form input[name='q']").val();
  // return amount without *
  if ($(".search__form input[name='q']").length > 0) {
    $(".search__form input[name='q']").val(currentValue.replace("*", ""));
  }

  // Collection sorting

  const sortByEl = document.querySelector("[data-sort-by]");

  if (sortByEl) {
    sortByEl.addEventListener("change", (e) => {
      const { target } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set("sort_by", sortValue);
        window.location.search = queryString;
      }
    });
  }

  $("body").on("change", "#tag_filter", () => {
    $("[data-option-filter] input").prop("checked", false);
    window.quickFilter.init();
  });

  $("body").on("change", "#blog_filter", function () {
    const url = $(this).val();
    window.location = url;
  });

  $("input, select, textarea").on("focus blur", (event) => {
    $("meta[name=viewport]").attr(
      "content",
      `width=device-width,initial-scale=1,maximum-scale=${
        event.type === "blur" ? 10 : 1
      }`
    );
  });

  // Collection sidebar filter
  // Check the checkbox values
  $("body").on("change", "[data-option-filter] input", () => {
    window.quickFilter.init();
    $("html, body").animate(
      {
        scrollTop: $(".content").offset().top,
      },
      500
    );
  });

  $("body").on("click", "[data-reset-filters]", () => {
    window.collectionSidebarFilter.clearAllFilters();
  });

  $("body").on("click", "[data-clear-filter]", (e) => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents(".filter-active-tag");
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $("body").on("change", ".currencies", () => {
    $("[data-initial-modal-price]").attr("data-initial-modal-price", "");
  });

  $("body").on("change", ".js-quick-shop select", () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });

  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }

  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document)
    .bind("touchstart", () => {
      touchStartPos = $(window).scrollTop();
    })
    .bind("touchend", (e) => {
      const distance = touchStartPos - $(window).scrollTop();
      if (distance > 20 || distance < -20) {
        e.preventDefault;
      }
    });

  $("body").on("click", ".sidebar .parent-link--false", function (e) {
    e.preventDefault();
    const $menu = $(this).parent("li");
    $menu.find(".menu-toggle").toggleClass("active");
    $menu.find("ul").slideToggle();
  });

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if (window.location.pathname.indexOf("/comments") !== -1) {
    $("html,body").animate(
      { scrollTop: $("#new-comment").offset().top - 140 },
      "slow"
    );
  }

  $("body").on("mouseenter", ".icon-search", () => {
    $(".search-terms").focus();
  });

  $("body").on("click", ".icon-search", () => {
    $("input.search-terms").focus();
  });

  $("body").on("click", ".search-submit", (e) => {
    const $this = $(e.currentTarget);
    $this.parent().submit();
  });

  if (window.PXUTheme.media_queries.large.matches) {
    $(".animate_right").waypoint(
      function () {
        $(this.element).addClass("animated fadeInRight");
      },
      { offset: "70%" }
    );
    $(".animate_left").waypoint(
      function () {
        $(this.element).addClass("animated fadeInLeft");
      },
      { offset: "70%" }
    );
    $(".animate_up").waypoint(
      function () {
        $(this.element).addClass("animated fadeInUp");
      },
      { offset: "70%" }
    );
    $(".animate_down").waypoint(
      function () {
        $(this.element).addClass("animated fadeInDown");
      },
      { offset: "70%" }
    );
  }

  // backwards compatibility with flexslider
  $(".slider, .flexslider").find("li").unwrap();
  $(".slider, .flexslider").flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2,
  });

  const disabled_toggle = $(".disabled__toggle__mobile--true").length;
  if (!disabled_toggle) {
    window.utils.createAccordion(".footer_menu", "h6", "ul");
    window.utils.createAccordion(".footer_content", "h6", "div.toggle_content");
  }
  window.utils.createAccordion(
    ".product_section .accordion-tabs",
    ".tabs li > a",
    ".tabs-content li"
  );
  window.utils.mobileParentActiveAccordion(
    "#mobile_menu",
    "li.sublink > a.parent-link--true span",
    "li.sublink ul"
  );
  window.utils.mobileAccordion(
    "#mobile_menu",
    "li.sublink > a.parent-link--false",
    "li.sublink ul"
  );

  window.utils.initializeTabs();
  window.accordion.init();

  $("body").on("click", ".menu-toggle", function () {
    const $content = $(this).next("ul");
    $content.slideToggle();
    $(this).toggleClass("active");
    $(this).attr(
      "aria-expanded",
      $(this).attr("aria-expanded") === "true" ? "false" : "true"
    );
  });

  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $("body").on("mouseenter", ".collection_swatches", function () {
        $(".swatch span", $(this)).each(function () {
          if ($(this).data("image").indexOf("no-image") === -1) {
            $("<img/>")[0].src = $(this).data("image");
          }
        });
      });
      $("body").on("mouseenter", ".swatch span", function () {
        if ($(this).data("image").indexOf("no-image") === -1) {
          $(this)
            .parents(".thumbnail")
            .find(".image__container img:not(.secondary)")
            .attr("src", $(this).data("image"));
          $(this)
            .parents(".thumbnail")
            .find(".image__container img:not(.secondary)")
            .attr("srcset", $(this).data("image"));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $("body").on("click touchstart", ".cart_content .tos_label", function () {
      $(this).prev("input").prop("checked", true);
    });
  }

  if (
    window.PXUTheme.theme_settings.display_tos_checkbox &&
    window.PXUTheme.theme_settings.go_to_checkout
  ) {
    // Terms of service on mini-cart && cart page
    $("body").on(
      "click",
      ".tos_warning [data-cart-checkout-button]",
      function (e) {
        if ($(this).parents("form").find(".tos_agree").is(":checked")) {
          // Check if we are on the cart page or mini cart
          if (
            window.PXUTheme.theme_settings.go_to_checkout ||
            $("body").hasClass("cart")
          ) {
            $(this).submit();
          } else {
            // Redirect to cart page
            e.preventDefault();
            document.location.href = window.PXUTheme.routes.cart_url;
          }
        } else {
          const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
          if ($("p.warning").length === 0) {
            $(this).before(warning);
          }
          return false;
        }
      }
    );
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $("body").on(
      "click",
      ".cart_content [data-minicart-checkout-button]",
      (e) => {
        // Redirect to cart page
        e.preventDefault();
        document.location.href = window.PXUTheme.routes.cart_url;
      }
    );
  }

  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($("[data-is-required]").length) {
    const $checkboxGroup = $(".custom-contact__checkbox");
    $checkboxGroup.prop("required", true);

    $checkboxGroup.on("change", () => {
      $checkboxGroup.prop("required", true);
      if ($checkboxGroup.is(":checked")) {
        $checkboxGroup.prop("required", false);
      }
    });
  }

  $(".maps").click(() => {
    $(".maps iframe").css("pointer-events", "auto");
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === "load_more") {
    window.enableLoadMoreProducts();
  }

  if (window.PXUTheme.theme_settings.pagination_type === "load_more_button") {
    window.enableLoadMoreButton(".product-list");
  }

  if (window.PXUTheme.theme_settings.pagination_type === "infinite_scroll") {
    window.enableInfiniteScroll(".product-list");
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  /** Header mini-cart count + sticky FAB badge (AJAX drawer). */
  function syncCartCountBadges(count) {
    const n = Number(count);
    const safe = Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0;
    $(".cart_count").text(String(safe));
    $("[data-sticky-cart-count]").text(String(safe));
    $(".sticky-cart-fab__badge").toggleClass(
      "sticky-cart-fab__badge--empty",
      safe === 0
    );
    $("#sticky-cart-fab").toggleClass("sticky-cart-fab--hidden-empty", safe === 0);
    if (safe > 0) {
      $(window).trigger("scroll");
    }
  }

  /** sessionStorage key for cart hold timer (survives AJAX section HTML swaps). */
  const CART_HOLD_DEADLINE_STORAGE_KEY = "spf_cart_hold_deadline_ms";

  let cartCheckoutCountdownTimerId = null;

  function clearCartCheckoutCountdownTimer() {
    if (cartCheckoutCountdownTimerId != null) {
      clearInterval(cartCheckoutCountdownTimerId);
      cartCheckoutCountdownTimerId = null;
    }
  }

  /**
   * Cart page / drawer promo countdown. Logic lives here because scripts inside
   * Section Rendering HTML injected via jQuery do not run, which left the UI frozen after AJAX cart updates.
   * Deadline is persisted so line-item changes do not reset the timer.
   */
  function initCartCheckoutCountdown() {
    clearCartCheckoutCountdownTimer();
    const $root = $("[data-cart-countdown]").first();
    if (!$root.length) {
      try {
        sessionStorage.removeItem(CART_HOLD_DEADLINE_STORAGE_KEY);
      } catch (e) {}
      return;
    }

    const durationSec =
      parseInt($root.attr("data-countdown-duration-seconds"), 10) || 600;
    const endedMessage = $root.attr("data-countdown-ended-message") || "";
    const $display = $root.find(".js-cart-countdown-display");
    const $content = $root.find(".countdown-content");

    let deadlineMs;
    try {
      const raw = sessionStorage.getItem(CART_HOLD_DEADLINE_STORAGE_KEY);
      deadlineMs = raw ? parseInt(raw, 10) : NaN;
    } catch (e) {
      deadlineMs = NaN;
    }

    const now = Date.now();
    if (!Number.isFinite(deadlineMs) || deadlineMs <= now) {
      deadlineMs = now + durationSec * 1000;
      try {
        sessionStorage.setItem(
          CART_HOLD_DEADLINE_STORAGE_KEY,
          String(deadlineMs)
        );
      } catch (e) {}
    }

    function applyEndedState() {
      clearCartCheckoutCountdownTimer();
      if ($content.length && endedMessage) {
        $content.text(endedMessage);
      }
      try {
        sessionStorage.removeItem(CART_HOLD_DEADLINE_STORAGE_KEY);
      } catch (e) {}
    }

    function tick() {
      if (!$display.length) {
        clearCartCheckoutCountdownTimer();
        return;
      }
      const leftMs = deadlineMs - Date.now();
      if (leftMs <= 0) {
        applyEndedState();
        return;
      }
      const totalSec = Math.floor(leftMs / 1000);
      const minutes = Math.floor(totalSec / 60);
      const seconds = totalSec % 60;
      $display.text(
        `${minutes < 10 ? `0${minutes}` : minutes}:${
          seconds < 10 ? `0${seconds}` : seconds
        }`
      );
    }

    tick();
    cartCheckoutCountdownTimerId = window.setInterval(tick, 1000);
  }

  window.initCartCheckoutCountdown = initCartCheckoutCountdown;

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: cartApiUrl("cart/update.js"),
      dataType: "json",
      cache: false,
      type: "post",
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      },
    });
  }

  function fetchTemplateAndReplaceDOM(cart, cart_template, cart_id) {
    return new Promise((resolve, reject) => {
      $.ajax({
        url: `/?section_id=${cart_template}`,
        success: function (data) {
          const newSection = $(data).html();
          $(`#${cart_id}`)?.replaceWith(newSection);

          // Update cart count
          syncCartCountBadges(cart?.item_count);

          // Reinitialize scripts or event listeners
          window.cart.init();
          window.utils.initializeSectionWrapper();
          resolve();
        },
        error: function (err) {
          console.error(err);
          reject(err);
        },
      });
    });
  }
  function mergeSectionsResponse(response) {
    if (!response) return {};
    return response.sections || response;
  }

  /** Safe CSS id for jQuery, including dynamic Shopify section ids. */
  function escapeCssId(id) {
    if (typeof $ !== "undefined" && typeof $.escapeSelector === "function") {
      return $.escapeSelector(id);
    }
    return String(id).replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, "\\$1");
  }

  /**
   * Pick section HTML from Section Rendering JSON; handles rare key mismatch.
   */
  function getSectionHtml(sections, sectionId) {
    if (!sections || typeof sections !== "object") return null;
    let html = sections[sectionId];
    if (html != null && html !== "") return html;
    const keys = Object.keys(sections);
    if (keys.length === 1 && typeof sections[keys[0]] === "string") {
      return sections[keys[0]];
    }
    return null;
  }

  /** JSON template section id (e.g. cart.json `main`), not the Liquid file name. */
  function resolveCartPageSectionId() {
    const $root = $("#cart-template").closest(".shopify-section");
    const fromScript = $root.find("script[data-section-id]").first().attr("data-section-id");
    if (fromScript) return fromScript;
    const wrapId = $("#cart-template").closest("[id^='shopify-section-']").attr("id");
    return wrapId ? wrapId.replace(/^shopify-section-/, "") : "main";
  }

  /** Layout `` instance id for Section Rendering API (usually `cart-drawer`). */
  function getCartDrawerSectionId() {
    const $drawer = $("#cart-drawer");
    if (!$drawer.length) return "cart-drawer";
    const fromScript = $drawer
      .closest(".shopify-section")
      .find("script[data-section-id]")
      .first()
      .attr("data-section-id");
    if (fromScript) return fromScript;
    const wrapId = $drawer.closest("[id^='shopify-section-']").attr("id");
    return wrapId ? wrapId.replace(/^shopify-section-/, "") : "cart-drawer";
  }

  /** Theme cart link (relative or absolute) — use for Section Rendering GET/POST like Shopify examples. */
  function getThemeCartPageUrl() {
    return (
      (window.PXUTheme &&
        window.PXUTheme.routes &&
        window.PXUTheme.routes.cart_url) ||
      "/cart"
    );
  }

  /** Path for Cart API `sections_url` (must start with `/`). */
  function getSectionsUrlPath() {
    const raw = getThemeCartPageUrl();
    try {
      if (typeof window.URL !== "undefined" && window.location && window.location.origin) {
        return new URL(raw, window.location.origin).pathname || "/cart";
      }
    } catch (e) {}
    const q = raw.indexOf("?");
    return (q >= 0 ? raw.slice(0, q) : raw) || "/cart";
  }

  /** Current path + query for Cart API `sections_url` (drawer section renders in page context). */
  function getCurrentPageSectionsUrl() {
    const p = window.location;
    if (!p) return "/";
    return (p.pathname || "/") + (p.search || "");
  }

  /** Appends `sections` + `sections_url` to POST cart/add.js when cart-drawer exists (Shopify bundled section rendering). */
  function appendAddToCartBundledSections(postData) {
    if (!$("#cart-drawer").length) return postData;
    const sid = getCartDrawerSectionId();
    const surl = getCurrentPageSectionsUrl();
    const sep = postData && String(postData).length ? "&" : "";
    return (
      postData +
      sep +
      "sections=" +
      encodeURIComponent(sid) +
      "&sections_url=" +
      encodeURIComponent(surl)
    );
  }

  function cartApiUrl(suffix) {
    let root =
      (typeof window.Shopify !== "undefined" &&
        window.Shopify.routes &&
        window.Shopify.routes.root) ||
      (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.root_url);
    if (root == null || root === "") root = "/";
    const clean = String(suffix).replace(/^\//, "");
    const base = root.endsWith("/") ? root : `${root}/`;
    return base + clean;
  }

  /**
   * Bundled Section Rendering on POST /cart/change.js (cart page and/or drawer).
   * Drawer-only views use the current page URL for `sections_url` so layout matches.
   */
  function addBundledSectionsToChangePayload(payload) {
    if ($("#cart-template").length) {
      payload.sections = resolveCartPageSectionId();
      payload.sections_url = getSectionsUrlPath();
      return;
    }
    if ($("#cart-drawer").length) {
      payload.sections = getCartDrawerSectionId();
      payload.sections_url = getCurrentPageSectionsUrl();
    }
  }

  /**
   * Cart page section AJAX replace swaps the whole section including `#cart-remove-modal-template`.
   * Re-bind CustomModal so `window.customModals['cart-remove-modal-template']` targets live DOM.
   */
  function reinitializeCartRemoveModalTemplate() {
    if (typeof window.CustomModal === "undefined") return;
    if (!$("#cart-remove-modal-template").length) return;
    window.customModals = window.customModals || {};
    window.customModals["cart-remove-modal-template"] = new window.CustomModal(
      "cart-remove-modal-template"
    );
  }

  function reinitializeCartPageSection() {
    reinitializeCartRemoveModalTemplate();
    window.cart.init();
    window.utils.initializeSectionWrapper();
    if (
      window.PXUTheme.currency.show_multiple_currencies &&
      window.currencyConverter
    ) {
      window.currencyConverter.convertCurrencies();
    }
    initCartCheckoutCountdown();
  }

  /**
   * Replace cart page section markup from Section Rendering HTML string.
   * Prefers full `#shopify-section-{id}` replace; falls back to `#cart-template` innerHTML.
   */
  function replaceCartPageSectionFromHtml(html, sectionId) {
    if (html == null || html === "") return;
    const sid = sectionId || resolveCartPageSectionId();
    const $parsed = $("<div>").append($.parseHTML(html, document, true));
    const $liveWrapper = $("#cart-template").closest(".shopify-section");
    const wrapperDomId = "shopify-section-" + sid;
    let $newWrapper = $parsed.find("#" + escapeCssId(wrapperDomId)).first();
    if (!$newWrapper.length) {
      $newWrapper = $parsed.find(".shopify-section--cart-template").first();
    }
    if ($newWrapper.length && $liveWrapper.length) {
      $liveWrapper.replaceWith($newWrapper);
    } else {
      const $newInner = $parsed.find("#cart-template");
      const $liveCart = $("#cart-template");
      if ($newInner.length && $liveCart.length) {
        $liveCart.html($newInner.html());
      }
    }
    reinitializeCartPageSection();
  }

  /**
   * Uses `sections` from POST /cart/change.js (bundled rendering). Returns true if DOM updated.
   */
  function applyCartPageFromChangeResponse(cartJson) {
    if (!$("#cart-template").length || !cartJson) return false;
    const sectionId = resolveCartPageSectionId();
    const sections = mergeSectionsResponse(cartJson);
    const html = getSectionHtml(sections, sectionId);
    if (html == null || html === "") return false;
    replaceCartPageSectionFromHtml(html, sectionId);
    return true;
  }

  /**
   * GET fallback when bundled `sections` missing (older cart flows).
   */
  function fetchCartPageSectionByGet(cart) {
    return new Promise((resolve, reject) => {
      if (!$("#cart-template").length) {
        resolve();
        return;
      }
      const sectionId = resolveCartPageSectionId();
      // Use Shopify Section Rendering endpoint on root + sections_url to avoid stale page-context fragments.
      $.ajax({
        url: "/",
        data: {
          sections: sectionId,
          sections_url: getSectionsUrlPath(),
          _: Date.now(),
        },
        dataType: "json",
        cache: false,
      })
        .done((response) => {
          const sections = mergeSectionsResponse(response);
          const html = getSectionHtml(sections, sectionId);
          if (html == null || html === "") {
            resolve();
            return;
          }
          replaceCartPageSectionFromHtml(html, sectionId);
          resolve();
        })
        .fail(reject);
    });
  }

  /** Replace drawer body/title from Section Rendering HTML (bundled Cart API response or GET). */
  function patchCartDrawerFromSectionHtml(html) {
    if (html == null || html === "") return;
    const $parsed = $("<div>").append($.parseHTML(html, document, true));
    const $drawer = $("#cart-drawer");
    const $newBody = $parsed.find("[data-cart-drawer-body]");
    const $target = $drawer.find("[data-cart-drawer-body]");
    if ($newBody.length && $target.length) {
      $target.html($newBody.html());
      const itemCount = $newBody.attr("data-cart-item-count");
      if (itemCount !== undefined && itemCount !== null) {
        $target.attr("data-cart-item-count", itemCount);
        syncCartCountBadges(parseInt(itemCount, 10));
      }
    }
    const $newTitle = $parsed.find(".cart-drawer__title");
    if ($newTitle.length) {
      $drawer.find(".cart-drawer__title").html($newTitle.html());
    }
    window.cart.init();
    window.utils.initializeSectionWrapper();
    if (
      window.PXUTheme.currency.show_multiple_currencies &&
      window.currencyConverter
    ) {
      window.currencyConverter.convertCurrencies();
    }
    initCartCheckoutCountdown();

    // Trigger cart.js fetch so third-party customizer apps (like Teeinblue) can detect cart DOM update and re-render
    document.dispatchEvent(new CustomEvent('shopify-event-cart-updated'));
  }

  /** Apply `sections` from POST /cart/change.js when the drawer is the active cart UI. */
  function applyCartDrawerFromChangeResponse(cartJson) {
    if (!$("#cart-drawer").length || $("#cart-template").length || !cartJson) {
      return false;
    }
    const drawerSectionId = getCartDrawerSectionId();
    const sections = mergeSectionsResponse(cartJson);
    const html = getSectionHtml(sections, drawerSectionId);
    if (html == null || html === "") return false;
    patchCartDrawerFromSectionHtml(html);
    return true;
  }

  /** After line change/remove: refresh cart page section and/or drawer via GET if not already patched from POST. */
  function refreshAjaxCartSurfaces(cart, options) {
    const opts = options || {};
    return new Promise((resolve, reject) => {
      const hasTemplate = $("#cart-template").length > 0;
      const hasDrawer = $("#cart-drawer").length > 0;

      if (!hasTemplate && !hasDrawer) {
        syncCartCountBadges(cart?.item_count ?? 0);
        resolve();
        return;
      }

      const tasks = [];

      if (hasTemplate && !opts.skipCartTemplate) {
        tasks.push(fetchCartPageSectionByGet(cart));
      }

      if (hasDrawer && window.CartDrawer && !opts.skipDrawer) {
        tasks.push(CartDrawer.refresh({ skipOverlay: true }));
      }

      Promise.all(tasks).then(resolve).catch(reject);
    });
  }

  /**
   * Slide-out cart drawer (non–cart pages). Refreshes markup via Section Rendering API.
   */
  const CartDrawer = {
    // @param skipOverlay — skip overlay when caller already showed it (e.g. cart qty update).
    refresh(options) {
      const opts = options || {};
      const skipOverlay = !!opts.skipOverlay;
      const $drawer = $("#cart-drawer");
      if (!$drawer.length) {
        return $.Deferred().resolve().promise();
      }
      if (!skipOverlay) showUIBlock();
      const drawerSectionId = getCartDrawerSectionId();
      return $.ajax({
        url: "/",
        data: {
          sections: drawerSectionId,
          sections_url: getCurrentPageSectionsUrl(),
          _: Date.now(),
        },
        dataType: "json",
        cache: false,
      }).done((response) => {
        const sections = mergeSectionsResponse(response);
        const html = getSectionHtml(sections, drawerSectionId);
        if (html != null && html !== "") {
          patchCartDrawerFromSectionHtml(html);
        }
      })
        .always(() => {
          if (!skipOverlay) hideUIBlock();
        });
    },
    open() {
      if (!$("#cart-drawer").length) return;
      $("html").addClass("cart-drawer-open");
      $("body").addClass("cart-drawer-open blocked-overflow");
      $("#cart-drawer").attr("aria-hidden", "false");
    },
    close() {
      $("html").removeClass("cart-drawer-open");
      $("body").removeClass("cart-drawer-open blocked-overflow");
      $("#cart-drawer").attr("aria-hidden", "true");
    },
    /** Drawer markup was not in POST /cart/add.js response — refresh via Section Rendering GET, then open. */
    openAfterAdd() {
      if (!$("#cart-drawer").length) return;
      CartDrawer.open();
      CartDrawer.refresh({ skipOverlay: false });
    },
    openFromHeader() {
      if (!$("#cart-drawer").length) return;
      // Open immediately for perceived speed, then refresh section in-place.
      CartDrawer.open();
      CartDrawer.refresh({ skipOverlay: false });
    },
  };
  window.CartDrawer = CartDrawer;

  /**
   * After POST /cart/add.js: drawer HTML should come from `addResponse.sections` (bundled rendering, same request as add).
   * If missing, `openAfterAdd` refetches section HTML via GET (CartDrawer.refresh).
   */
  function openCartDrawerAfterAjaxAdd(addResponse) {
    const drawerSid = getCartDrawerSectionId();
    const html = getSectionHtml(mergeSectionsResponse(addResponse), drawerSid);
    if (html != null && html !== "") {
      patchCartDrawerFromSectionHtml(html);
      CartDrawer.open();
      return;
    }
    CartDrawer.openAfterAdd();
  }

  /** External-app add flow: single refresh cycle, no retry. */
  function openCartDrawerAfterExternalAdd() {
    CartDrawer.refresh({ skipOverlay: true }).always(() => {
      CartDrawer.open();
    });
  }

  function fetchLatestCartAfterAdd() {
    return $.ajax({
      url: `${cartApiUrl("cart.js")}?_ts=${Date.now()}`,
      dataType: "json",
      cache: false,
    });
  }

  function handleCartAddSuccess(detail) {
    const payload = detail || {};
    const addResponse = payload.addResponse || null;

    function finishWithCart(cart) {
      refreshCart(cart);

      if ($("body").hasClass("fancybox-active")) {
        $.fancybox.close();
      }

      const isAjaxCart = window.PXUTheme.theme_settings.cart_action === "ajax";
      if (isAjaxCart && $("#cart-drawer").length && window.CartDrawer) {
        if (addResponse) {
          openCartDrawerAfterAjaxAdd(addResponse);
        } else {
          openCartDrawerAfterExternalAdd();
        }
        return;
      }

      if (!isAjaxCart) {
        window.location.href = window.PXUTheme.routes.cart_url;
        return;
      }

      if ($("#header").is(":visible")) {
        $("#header .cart-container").addClass("active_link");
      } else if ($(".sticky_nav--stick").length) {
        $(".sticky_nav .cart-container").addClass("active_link");
      } else {
        $(".top-bar .cart-container").addClass("active_link");
      }

      if (
        window.PXUTheme.media_queries.medium.matches &&
        !$("#cart-drawer").length
      ) {
        $("body").addClass("blocked-scroll");
        const header = document.getElementById("header");
        if (
          header &&
          header.classList.contains("mobile_nav-fixed--false")
        ) {
          window.scroll({ top: 0, left: 0, behavior: "smooth" });
        }
      }
    }

    if (payload.cart && payload.cart.items) {
      finishWithCart(payload.cart);
      return;
    }

    fetchLatestCartAfterAdd().done(finishWithCart).fail(() => {
      if ($("#cart-drawer").length && window.CartDrawer) {
        if (addResponse) {
          openCartDrawerAfterAjaxAdd(addResponse);
        } else {
          openCartDrawerAfterExternalAdd();
        }
      }
    });
  }

  // Expose direct hook for third-party bridges when document event isn't caught.
  window.spfHandleCartAddSuccess = handleCartAddSuccess;

  $("body").on("click", "[data-cart-drawer-close]", function (e) {
    e.preventDefault();
    CartDrawer.close();
  });
  function isThemeCartTemplatePage() {
    return document.body && document.body.classList.contains("cart");
  }
  $(document).on("keydown.cartDrawer", function (e) {
    if (isThemeCartTemplatePage()) return;
    if (e.key !== "Escape") return;
    if ($(".custom-modal.is-active").length) return;
    if (!$("body").hasClass("cart-drawer-open")) return;
    CartDrawer.close();
  });
  if (
    window.PXUTheme.theme_settings.cart_action === "ajax" &&
    document.getElementById("cart-drawer")
  ) {
    $("body").addClass("cart-action--ajax-drawer");
    $(".mini_cart").off("click");
    $(".cart-container").off("mouseenter").off("mouseleave");
    $(document).on("click.cartDrawerHeader", ".cart-container .mini_cart", function (e) {
      if (isThemeCartTemplatePage()) return;
      e.preventDefault();
      CartDrawer.openFromHeader();
    });
    $(document).on("click.cartDrawerFab", "#sticky-cart-fab", function (e) {
      if (isThemeCartTemplatePage()) return;
      e.preventDefault();
      CartDrawer.openFromHeader();
    });
    $(document).on(
      "click.cartDrawerHeader2026",
      "a.header_btn-icon-cart",
      function (e) {
        if (isThemeCartTemplatePage()) return;
        e.preventDefault();
        CartDrawer.openFromHeader();
      }
    );
  }

  if ($("[data-cart-countdown]").length) {
    initCartCheckoutCountdown();
  }

  // Unified post-add event entry point (theme + external apps).
  document.addEventListener("spf:cart:add:success", function (event) {
    handleCartAddSuccess((event && event.detail) || {});
  });

  function completeCartLineChangeUi(itemKey, quantity, cart, options) {
    const opts = options || {};
    refreshAjaxCartSurfaces(cart, {
      skipCartTemplate: !!opts.skipCartTemplate,
      skipDrawer: !!opts.skipDrawer,
    })
      .catch(() => {})
      .finally(() => {
        syncCartCountBadges(cart?.item_count ?? 0);
        hideUIBlock();
      });
  }
  // Helper functions for UI blocking
  function showUIBlock() {
    // Add loading overlay if needed
    if (!$("#ui-block-overlay").length) {
      $("body").append(`
        <div id="ui-block-overlay" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;">
          <div class="loading-spinner" style="width: 40px; height: 40px;">
            <svg viewBox="0 0 50 50" style="animation: rotate 1s linear infinite;">
              <circle
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke="#ffffff"
                stroke-width="4"
                stroke-dasharray="60, 150"
                style="animation: dash 1.5s ease-in-out infinite"
              />
            </svg>
          </div>
        </div>
      `);

      // Add animation and scroll-lock styles
      if (!$("#cart-loading-styles").length) {
        const styleSheet = document.createElement("style");
        styleSheet.id = "cart-loading-styles";
        styleSheet.textContent = `
          @keyframes rotate {
            100% { transform: rotate(360deg); }
          }
          @keyframes dash {
            0% { stroke-dasharray: 1, 150; stroke-dashoffset: 0; }
            50% { stroke-dasharray: 90, 150; stroke-dashoffset: -35; }
            100% { stroke-dasharray: 90, 150; stroke-dashoffset: -124; }
          }
          body.cart-loading {
            overflow: hidden !important;
            position: relative;
          }
        `;
        document.head.appendChild(styleSheet);
      }
    }
    
    // Show overlay and disable scroll
    $("#ui-block-overlay").show();
    $("body").addClass("cart-loading");
  }

  function hideUIBlock() {
    $("#ui-block-overlay").hide();
    $("body").removeClass("cart-loading");
    $("#cart_form .js-change-quantity, .cart_content .js-change-quantity").removeClass(
      "is-disabled"
    );
  }
  async function syncCartLineQuantity(qty, itemId, itemKey) {
    if (qty === 0) {
      try {
        await new Promise((resolve, reject) => {
          $.ajax({
            type: "GET",
            url: cartApiUrl("cart.js"),
            dataType: "json",
            success: resolve,
            error: reject,
          });
        });

        const allItemsToRemove = [itemId].sort((a, b) => b - a);
        let lastChangePayload = null;

        for (let i = 0; i < allItemsToRemove.length; i++) {
          const lineId = allItemsToRemove[i];
          const isLast = i === allItemsToRemove.length - 1;
          try {
            const payload = {
              line: +lineId,
              quantity: 0,
            };
            if (
              isLast &&
              ($("#cart-template").length || $("#cart-drawer").length)
            ) {
              addBundledSectionsToChangePayload(payload);
            }
            lastChangePayload = await new Promise(function (resolve, reject) {
              $.ajax({
                type: "POST",
                url: cartApiUrl("cart/change.js"),
                data: JSON.stringify(payload),
                dataType: "json",
                contentType: "application/json",
                success: resolve,
                error: reject,
              });
            });
          } catch (error) {
            console.error(`Failed to remove item ${lineId}:`, error);
          }
        }

        const updatedCart = await new Promise((resolve, reject) => {
          $.ajax({
            type: "GET",
            url: cartApiUrl("cart.js"),
            dataType: "json",
            success: resolve,
            error: reject,
          });
        });

        const cartForUi = lastChangePayload && lastChangePayload.item_count !== undefined
          ? lastChangePayload
          : updatedCart;
        const bundledPageOk =
          !!(
            $("#cart-template").length &&
            lastChangePayload &&
            applyCartPageFromChangeResponse(lastChangePayload)
          );
        const bundledDrawerOk =
          !!(
            $("#cart-drawer").length &&
            !$("#cart-template").length &&
            lastChangePayload &&
            applyCartDrawerFromChangeResponse(lastChangePayload)
          );
        completeCartLineChangeUi(itemKey, 0, cartForUi, {
          skipCartTemplate: bundledPageOk,
          skipDrawer: bundledDrawerOk,
        });
      } catch (error) {
        console.error("Error removing item:", error);
        hideUIBlock();
      }
    } else {
      try {
        const payload = {
          line: +itemId,
          quantity: +qty,
        };
        addBundledSectionsToChangePayload(payload);

        const cart = await new Promise((resolve, reject) => {
          $.ajax({
            type: "POST",
            url: cartApiUrl("cart/change.js"),
            data: JSON.stringify(payload),
            dataType: "json",
            contentType: "application/json",
            success: resolve,
            error: reject,
          });
        });

        const bundledPageOk =
          $("#cart-template").length && applyCartPageFromChangeResponse(cart);
        const bundledDrawerOk =
          $("#cart-drawer").length &&
          !$("#cart-template").length &&
          applyCartDrawerFromChangeResponse(cart);
        completeCartLineChangeUi(itemKey, +qty, cart, {
          skipCartTemplate: bundledPageOk,
          skipDrawer: bundledDrawerOk,
        });
      } catch (error) {
        console.error("Error updating quantity:", error);
        hideUIBlock();
      }
    }
  }
  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: cartApiUrl("cart/change.js"),
      dataType: "json",
      cache: false,
      type: "post",
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID,
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems =
          cartItem.parentCartForm.find("[data-variant-id]").length;
        const $quantityInputs = cartItem.parentCartForm.find(
          `[data-variant-id="${cartItem.variantID}"] input`
        );
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity =
          typeof data.items[lineIDIndex] !== "undefined"
            ? data.items[lineIDIndex].quantity
            : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach((item) => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal =
            typeof data.items[lineIDIndex] !== "undefined"
              ? data.items[lineIDIndex].quantity
              : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (
          initialQuantityTotal > 0 &&
          initialQuantityTotal > apiQuantityTotal
        ) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }

          $(".warning--quantity").remove();

          // Check if Buy one get one product
          // if (totalCartItems < cartItemsArray.length) {
          if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
            // Refreshes cart if inventory is available
            cartItem.parentCartForm.submit();
          } else {
            refreshCart(data);
          }
          // } else {
          //   const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
          //   cartItem.parentCartForm
          //     .find(`[data-line-id='${cartItem.lineID}'] input`)
          //     .parent()
          //     .after(warning);
          //   cartItem.parentCartForm
          //     .find(`[data-line-id='${cartItem.lineID}'] input`)
          //     .val(apiLineItemQuantity);
          // }
        } else if (
          cartItem.parentCartForm.data("cart-form") === "cart-template"
        ) {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      },
    });
  }

  function refreshCartID() {
    const cartItem = document.querySelectorAll(".cart__item");

    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll("[data-line-id]");

      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function refreshCart(cart) {
    syncCartCountBadges(cart.item_count);
    // Temporarily disable mini-cart rendering/update logic.
    // Current phase focuses on cart-drawer only.
    return;
    let cartItemsHTML = "";
    let cartDiscountsHTML = "";
    let cartActionHTML = "";
    let cartSavingsHTML = "";
    const $miniCartForm = $('form[data-cart-form="mini-cart"]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    if ($miniCartForm.length) {
      $miniCartForm.data("total-discount", cart.total_discount);
    }

    if (cart.item_count === 0) {
      if ($miniCartForm.length) {
        $miniCartForm.closest(".cart-container").find(".js-empty-cart__message").removeClass("hidden");
        $miniCartForm.addClass("hidden");
      }
    } else {
      if ($miniCartForm.length) {
        $miniCartForm.closest(".cart-container").find(".js-empty-cart__message").addClass("hidden");
        $miniCartForm.removeClass("hidden");
      }

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      $.each(cart.items || [], (index, item) => {
        const itemDiscounts = item.discounts || [];
        let discountMessage = "";

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;

        cartItemsHTML +=
          `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">` +
          `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML +=
            `${'<div class="cart_image">' + '<img src="'}${item.image
              .replace(/(\.[^.]*)$/, "_compact$1")
              .replace("http:", "")}" alt="${htmlEncode(item.title)}" />` +
            "</div></a>";
        }

        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;

        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }

        if (item.properties) {
          $.each(item.properties, (title, value) => {
            if (value) {
              cartItemsHTML += `<div class="line-item">${title}: ${value} </div>`;
            }
          });
        }

        cartItemsHTML += '</div><div class="mini-cart__item-price">';

        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          url: cartApiUrl(`products/${item.handle}.js`),
          success(data) {
            let productData = data;
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (productData.variants) {
              const itemVariants = productData.variants;
              if (itemVariants.length > 1) {
                for (let v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id === item.id) {
                    productData = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (productData.compare_at_price) {
              if (productData.compare_at_price > productData.price) {
                productHasSale = true;
                productCompareAtPrice = productData.compare_at_price;
                productFinalPrice = productData.price;
              }
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          },
        });

        if (productHasSale === true) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(
            productFinalPrice,
            $("body").data("money-format")
          )} </span><span class="money was_price">${window.Shopify.formatMoney(
            productCompareAtPrice,
            $("body").data("money-format")
          )}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

          // Total savings
          saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          totalSaving = saving + totalSaving;
        } else if (item.price > item.final_price) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(
            item.final_price,
            $("body").data("money-format")
          )} </span><span class="money was_price">${window.Shopify.formatMoney(
            item.price,
            $("body").data("money-format")
          )}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
        } else {
          const itemPrice = window.Shopify.formatMoney(
            item.price,
            $("body").data("money-format")
          );
          if (item.price > 0) {
            cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
          } else {
            cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
          }
        }

        cartItemsHTML += "</div>";

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = "";

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue =
              item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${
            item.unit_price_measurement.quantity_value
          }${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(
            item.unit_price,
            $("body").data("money-format")
          )} / ${unitPriceMeasurementReferenceValue}${
            item.unit_price_measurement.reference_unit
          }</p>`;
        }

        if (item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }

        cartItemsHTML += '<div class="product-quantity-box">';
        cartItemsHTML +=
          '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML +=
          '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cartItemsHTML += "</div></div></div>";
        cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
      });

      const cartDiscounts = cart.cart_level_discount_applications || [];

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(
          cartDiscounts[i].total_allocated_amount,
          $("body").data("money-format")
        );
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(
        cart.total_price,
        $("body").data("money-format")
      )}</span></span> <span>${
        window.PXUTheme.translation.cart_subtotal_text
      }</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML =
          `<span class="right"><span class="money">${window.Shopify.formatMoney(
            totalSaving,
            $("body").data("money-format")
          )}</span></span>` +
          `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = "";
      }
    }

    if ($miniCartForm.length) {
      $miniCartForm.find(".js-cart_items").html(cartItemsHTML);
      $miniCartForm.find(".js-cart_discounts").html(cartDiscountsHTML);
      $miniCartForm.find(".js-cart_subtotal").html(cartActionHTML);
      $miniCartForm.find(".js-cart_savings").html(cartSavingsHTML);
    } else {
      $("#header .js-cart_items").html(cartItemsHTML);
      $("#header .js-cart_discounts").html(cartDiscountsHTML);
      $("#header .js-cart_subtotal").html(cartActionHTML);
      $("#header .js-cart_savings").html(cartSavingsHTML);
    }

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }

  function callAPIUpdateCartPageCart(qty, itemId, itemKey) {
    $.ajax({
      type: "GET",
      url: cartApiUrl("cart.js"),
      dataType: "json",
      success: function (cart) {
        const item = cart.items[itemId - 1];
        const isSubItem = item && item.properties && item.properties._is_sub_item === "true";
        
        if (isSubItem) {
          // Sub-item update logic (currently not implemented)
          console.warn("Sub-item update not implemented");
          hideUIBlock();
        } else {
          syncCartLineQuantity(Number(qty), itemId, itemKey);
        }
      },
      error: function (err) {
        console.error("Error getting cart:", err);
        hideUIBlock();
      },
    });
  }

  /** Drawer vs cart page use different modal ids (both can exist on /cart — duplicate ids broke CustomModal). */
  function resolveCartRemoveModal($fromEl) {
    const m = window.customModals;
    if (!m) return null;

    if ($fromEl.closest("#cart-drawer").length) {
      return m["cart-remove-modal-drawer"] || null;
    }
    if ($fromEl.closest("#cart-template").length) {
      return m["cart-remove-modal-template"] || null;
    }
    // Mini-cart / header: not inside drawer or cart section
    if (document.body && document.body.classList.contains("cart")) {
      return m["cart-remove-modal-template"] || m["cart-remove-modal-drawer"] || null;
    }
    return m["cart-remove-modal-drawer"] || m["cart-remove-modal-template"] || null;
  }

  function closeCartRemoveModals() {
    ["cart-remove-modal-drawer", "cart-remove-modal-template"].forEach((key) => {
      if (window.customModals && window.customModals[key]) {
        window.customModals[key].close();
      }
    });
  }

  // Handle cart remove button click (with event delegation for dynamic elements)
  $("body").on("click", ".cart__remove-btn", function (e) {
    e.preventDefault();
    
    try {
      const removeModal = resolveCartRemoveModal($(this));
      if (!removeModal) return;

      const $cartItem = $(this).closest(".cart__item");
      const lineId = $cartItem.data("line-id");
      const itemKey = $cartItem.data("key");
      const preview_url = $cartItem.find(".cart__item--image img").attr("src");

      const $preview = removeModal.modal.find(".js-cart-remove-preview").first();
      if ($preview.length) {
        $preview.html(
          `<img src='${preview_url}' alt='Preview content' style='display: block; height: 100%; width: 100%;'>`
        );
      }

      // Setup remove button click handler
      const removeItemBtn = removeModal.modal.find(".js-remove-item");
      removeItemBtn.off("click").on("click", function (e) {
        e.preventDefault();
        document.dispatchEvent(
          new CustomEvent("removeItem", {
            detail: { lineId, itemKey },
          })
        );
      });

      // Open confirmation modal
      removeModal.open();
    } catch (error) {
      console.error("Error in cart remove handler:", error);
    }
  });

  // Handle quantity change
  $("body").on("change", "[data-cart-quantity-input]", function () {
    const $cartItem = $(this).parents("[data-cart-item]");
    const cartItem = {
      lineID: $cartItem.data("line-id"),
      variantID: $cartItem.data("variant-id"),
      quantity: $(this).val(),
      parentCartForm: $(this).parents("[data-cart-form]"),
      totalDiscount: $(this).parents("[data-cart-form]").data("total-discount"),
      $element: $cartItem,
      itemKey: $cartItem.data("key"),
    };

    // If quantity is changed to 0, show confirm modal
    if (cartItem.quantity === "0") {
      const removeModal = resolveCartRemoveModal($(this));
      if (!removeModal) {
        $(this).val(1);
        return;
      }

      const preview_url = $cartItem
        .find(".cart__item--image img")
        .attr("src");

      const $preview = removeModal.modal.find(".js-cart-remove-preview").first();
      if ($preview.length) {
        $preview.html(
          `<img src='${preview_url}' alt='Preview content' style='display: block; height: 100%; width: 100%;'>`
        );
      }

      // Setup remove button click handler
      const removeItemBtn = removeModal.modal.find(".js-remove-item");
      removeItemBtn.off("click").on("click", function (e) {
        e.preventDefault();
        document.dispatchEvent(
          new CustomEvent("removeItem", {
            detail: { lineId: cartItem.lineID, itemKey: cartItem.itemKey },
          })
        );
      });

      // Open confirmation modal
      removeModal.open();

      // Reset quantity to 1 while waiting for confirmation
      $(this).val(1);
      return;
    }
    
    showUIBlock();

    callAPIUpdateCartPageCart(
      cartItem.quantity,
      cartItem.lineID,
      cartItem.itemKey
    );
  });

  /*
   * Try to dismiss a preview/lightbox by clicking a close control when present.
   * @param  overlaySelector: string|null, closeButtonSelector?: string|null  [params]
   * @returns {boolean} true if a close control was clicked
   *
   * Defaults target Customily preview: overlay `.customily-modal-preview-only`, close `.customily-close-button`.
   * Pass `overlaySelector: null` to only match `closeButtonSelector` in the document.
   */
  window.closePreviewOverlayIfOpen = function closePreviewOverlayIfOpen(params) {
    const opts = params || {};
    const hasOverlayKey = Object.prototype.hasOwnProperty.call(opts, "overlaySelector");
    const hasCloseKey = Object.prototype.hasOwnProperty.call(opts, "closeButtonSelector");
    const overlaySel = hasOverlayKey ? opts.overlaySelector : ".customily-modal-preview-only";
    const closeSel = hasCloseKey ? opts.closeButtonSelector : ".customily-close-button";

    let closeEl = null;
    if (overlaySel) {
      const overlay = document.querySelector(overlaySel);
      if (overlay && closeSel) {
        closeEl = overlay.querySelector(closeSel);
      }
    }
    if (!closeEl && closeSel) {
      closeEl = document.querySelector(closeSel);
    }
    if (closeEl) {
      closeEl.click();
      return true;
    }
    return false;
  };

  if (window.PXUTheme.theme_settings.cart_action === "ajax") {
    $(document).on("click", ".ajax-submit", function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest("form");
      const $addToCartBtn = $addToCartForm.find(".add_to_cart");
      if ($("body").hasClass("cart")) {
        $addToCartForm.submit();
        return false;
      }

      // 1) POST cart/add.js — optional bundled `sections` for cart-drawer (Shopify Cart API).
      // 2) GET cart.js — source of truth for refreshCart (header mini-cart).
      // 3) Drawer: patch from addResponse.sections, else CartDrawer.refresh then open.
      $.ajax({
        url: cartApiUrl("cart/add.js"),
        dataType: "json",
        cache: false,
        type: "post",
        data: appendAddToCartBundledSections($addToCartForm.serialize()),
        beforeSend() {
          $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
          $addToCartBtn
            .find("span")
            .removeClass("fadeInDown")
            .addClass("animated zoomOut");
        },
        success(addResponse) {
          $addToCartBtn.find(".checkmark").addClass("checkmark-active");
          window.setTimeout(() => {
            $addToCartBtn.removeAttr("disabled").removeClass("disabled");
            $addToCartBtn.find(".checkmark").removeClass("checkmark-active");
            $addToCartBtn
              .find("span")
              .removeClass("zoomOut")
              .addClass("fadeInDown");
          }, 1000);
          window.closePreviewOverlayIfOpen();
          document.dispatchEvent(
            new CustomEvent("spf:cart:add:success", {
              detail: {
                addResponse,
                form: $addToCartForm[0] || null,
                source: "theme",
              },
            })
          );
        },
        error(XMLHttpRequest) {
          let response = "";
          try {
            const payload = JSON.parse(XMLHttpRequest.responseText || "{}");
            response = payload.description || payload.message || "";
          } catch (_err) {
            response = "";
          }
          if (!response) {
            response = window.PXUTheme.translation.cart_general_error || "Unable to add this item to cart.";
          }
          $(".warning").remove();

          const warning = `<p class="warning animated bounceIn">${response.replace(
            "All 1 ",
            "All "
          )}</p>`;
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr("disabled").removeClass("disabled");
          $addToCartBtn
            .find("span")
            .text(window.PXUTheme.translation.add_to_cart)
            .removeClass("zoomOut")
            .addClass("zoomIn");
        },
      });

      return false;
    });
  }

  document.addEventListener("removeItem", function (event) {
    showUIBlock();
    const { lineId, itemKey } = event.detail;
    
    closeCartRemoveModals();

    // Remove the item from cart
    callAPIUpdateCartPageCart(0, lineId, itemKey);
  });

  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  // FDUY
  // console.log(
  //   selectorIndex,
  //   $(`${parent} .single-option-selector:eq(0)`).val(),
  //   $(`${parent} .single-option-selector:eq(1)`).val()
  // );
  switch (selectorIndex) {
    case 0:
      var key = "root";
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }

  const availableOptions = Shopify.optionsMap[key];
  // FDUY
  // console.log({
  //   availableOptions,
  //   key,
  //   query: $(
  //     `${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`
  //   ),
  // });
  $(
    `${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`
  ).each(function () {
    if ($.inArray($(this).attr("data-value"), availableOptions) !== -1) {
      // FDUY
      // console.log($(this));
      $(this)
        .removeClass("soldout")
        .find(":radio")
        .removeAttr("disabled", "disabled")
        .removeAttr("checked");
    } else {
      $(this)
        .addClass("soldout")
        .find(":radio")
        .removeAttr("checked")
        .attr("disabled", "disabled");
    }
  });
};

window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(
        window.Shopify.optionsMap.root
      );
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(
          window.Shopify.optionsMap[key]
        );
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(
          window.Shopify.optionsMap[key]
        );
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1)
    window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3)
    window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    // console.log(`Right here no1`);
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3)
      window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3)
      window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $("<div/>").text(value).html();
  }
  return "";
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
  navigator.userAgent
);

/* option_selection.js */
function floatToString(t, e) {
  var o = t.toFixed(e).toString();
  return o.match(/^\.\d+/) ? "0" + o : o;
}
if ("undefined" == typeof window.Shopify) window.Shopify = {};
(window.Shopify.each = function (t, e) {
  for (var o = 0; o < t.length; o++) e(t[o], o);
}),
  (window.Shopify.map = function (t, e) {
    for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
    return o;
  }),
  (window.Shopify.arrayIncludes = function (t, e) {
    for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;
    return !1;
  }),
  (window.Shopify.uniq = function (t) {
    for (var e = [], o = 0; o < t.length; o++)
      window.Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e;
  }),
  (window.Shopify.isDefined = function (t) {
    return "undefined" == typeof t ? !1 : !0;
  }),
  (window.Shopify.getClass = function (t) {
    return Object.prototype.toString.call(t).slice(8, -1);
  }),
  (window.Shopify.extend = function (t, e) {
    function o() {}
    (o.prototype = e.prototype),
      (t.prototype = new o()),
      (t.prototype.constructor = t),
      (t.baseConstructor = e),
      (t.superClass = e.prototype);
  }),
  (window.Shopify.locationSearch = function () {
    return window.location.search;
  }),
  (window.Shopify.locationHash = function () {
    return window.location.hash;
  }),
  (window.Shopify.replaceState = function (t) {
    window.history.replaceState({}, document.title, t);
  }),
  (window.Shopify.urlParam = function (t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(
      window.Shopify.locationSearch()
    );
    return e && decodeURIComponent(e[1].replace(/\+/g, " "));
  }),
  (window.Shopify.newState = function (t, e) {
    var o;
    return (
      (o = window.Shopify.urlParam(t)
        ? window.Shopify.locationSearch().replace(
            RegExp("(" + t + "=)[^&#]+"),
            "$1" + e
          )
        : "" === window.Shopify.locationSearch()
        ? "?" + t + "=" + e
        : window.Shopify.locationSearch() + "&" + t + "=" + e),
      o + window.Shopify.locationHash()
    );
  }),
  (window.Shopify.setParam = function (t, e) {
    window.Shopify.replaceState(window.Shopify.newState(t, e));
  }),
  (window.Shopify.Product = function (t) {
    window.Shopify.isDefined(t) && this.update(t);
  }),
  (window.Shopify.Product.prototype.update = function (t) {
    for (property in t) this[property] = t[property];
  }),
  (window.Shopify.Product.prototype.optionNames = function () {
    return "Array" == window.Shopify.getClass(this.options) ? this.options : [];
  }),
  (window.Shopify.Product.prototype.optionValues = function (t) {
    if (!window.Shopify.isDefined(this.variants)) return null;
    var e = window.Shopify.map(this.variants, function (e) {
      var o = "option" + (t + 1);
      return void 0 == e[o] ? null : e[o];
    });
    return null == e[0] ? null : window.Shopify.uniq(e);
  }),
  (window.Shopify.Product.prototype.getVariant = function (t) {
    var e = null;
    return t.length != this.options.length
      ? e
      : (window.Shopify.each(this.variants, function (o) {
          for (var i = !0, r = 0; r < t.length; r++) {
            var n = "option" + (r + 1);
            o[n] != t[r] && (i = !1);
          }
          return 1 == i ? void (e = o) : void 0;
        }),
        e);
  }),
  (window.Shopify.Product.prototype.getVariantById = function (t) {
    for (var e = 0; e < this.variants.length; e++) {
      var o = this.variants[e];
      if (t == o.id) return o;
    }
    return null;
  }),
  (window.Shopify.money_format = "$"),
  (window.Shopify.formatMoney = function (t, e) {
    function o(t, e) {
      return "undefined" == typeof t ? e : t;
    }
    function i(t, e, i, r) {
      if (
        ((e = o(e, 2)), (i = o(i, ",")), (r = o(r, ".")), isNaN(t) || null == t)
      )
        return 0;
      t = (t / 100).toFixed(e);
      var n = t.split("."),
        a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
        s = n[1] ? r + n[1] : "";
      return a + s;
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      a = e || this.money_format;
    switch (a.match(n)[1]) {
      case "amount":
        r = i(t, 2);
        break;
      case "amount_no_decimals":
        r = i(t, 0);
        break;
      case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        r = i(t, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",");
    }
    return a.replace(n, r);
  }),
  (window.Shopify.OptionSelectors = function (t, e) {
    return (
      (this.selectorDivClass = "selector-wrapper"),
      (this.selectorClass = "single-option-selector"),
      (this.variantIdFieldIdSuffix = "-variant-id"),
      (this.variantIdField = null),
      (this.historyState = null),
      (this.selectors = []),
      (this.domIdPrefix = t),
      (this.product = new window.Shopify.Product(e.product)),
      (this.onVariantSelected = window.Shopify.isDefined(e.onVariantSelected)
        ? e.onVariantSelected
        : function () {}),
      this.replaceSelector(t),
      this.initDropdown(),
      e.enableHistoryState &&
        (this.historyState = new window.Shopify.OptionSelectors.HistoryState(
          this
        )),
      !0
    );
  }),
  (window.Shopify.OptionSelectors.prototype.initDropdown = function () {
    var t = { initialLoad: !0 },
      e = this.selectVariantFromDropdown(t);
    if (!e) {
      var o = this;
      setTimeout(function () {
        o.selectVariantFromParams(t) ||
          o.fireOnChangeForFirstDropdown.call(o, t);
      });
    }
  }),
  (window.Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown =
    function (t) {
      this.selectors[0].element.onchange(t);
    }),
  (window.Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown =
    function (t) {
      var e = this.selectVariantFromParams(t);
      e || this.selectVariantFromDropdown(t);
    }),
  (window.Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
    var e = document.getElementById(t),
      o = e.parentNode;
    window.Shopify.each(this.buildSelectors(), function (t) {
      o.insertBefore(t, e);
    }),
      (e.style.display = "none"),
      (this.variantIdField = e);
  }),
  (window.Shopify.OptionSelectors.prototype.selectVariantFromDropdown =
    function (t) {
      var e = document
        .getElementById(this.domIdPrefix)
        .querySelector("[selected]");
      if (
        (e ||
          (e = document
            .getElementById(this.domIdPrefix)
            .querySelector('[selected="selected"]')),
        !e)
      )
        return !1;
      var o = e.value;
      return this.selectVariant(o, t);
    }),
  (window.Shopify.OptionSelectors.prototype.selectVariantFromParams = function (
    t
  ) {
    var e = window.Shopify.urlParam("variant");
    return this.selectVariant(e, t);
  }),
  (window.Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
    var o = this.product.getVariantById(t);
    if (null == o) return !1;
    for (var i = 0; i < this.selectors.length; i++) {
      var r = this.selectors[i].element,
        n = r.getAttribute("data-option"),
        a = o[n];
      null != a && this.optionExistInSelect(r, a) && (r.value = a);
    }
    return (
      "undefined" != typeof jQuery
        ? jQuery(this.selectors[0].element).trigger("change", e)
        : this.selectors[0].element.onchange(e),
      !0
    );
  }),
  (window.Shopify.OptionSelectors.prototype.optionExistInSelect = function (
    t,
    e
  ) {
    for (var o = 0; o < t.options.length; o++)
      if (t.options[o].value == e) return !0;
  }),
  (window.Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
    window.Shopify.isDefined(e) && this.setMessageElement(e),
      (this.domIdPrefix = "product-" + this.product.id + "-variant-selector");
    var o = document.getElementById(t);
    window.Shopify.each(this.buildSelectors(), function (t) {
      o.appendChild(t);
    });
  }),
  (window.Shopify.OptionSelectors.prototype.buildSelectors = function () {
    for (var t = 0; t < this.product.optionNames().length; t++) {
      var e = new window.Shopify.SingleOptionSelector(
        this,
        t,
        this.product.optionNames()[t],
        this.product.optionValues(t)
      );
      (e.element.disabled = !1), this.selectors.push(e);
    }
    var o = this.selectorDivClass,
      i = this.product.optionNames(),
      r = window.Shopify.map(this.selectors, function (t) {
        var e = document.createElement("div");
        if ((e.setAttribute("class", o), i.length > 1)) {
          var r = document.createElement("label");
          (r.htmlFor = t.element.id), (r.innerHTML = t.name), e.appendChild(r);
        }
        return e.appendChild(t.element), e;
      });
    return r;
  }),
  (window.Shopify.OptionSelectors.prototype.selectedValues = function () {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
      var o = this.selectors[e].element.value;
      t.push(o);
    }
    return t;
  }),
  (window.Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
    var o = this.selectedValues(),
      i = this.product.getVariant(o);
    i
      ? ((this.variantIdField.disabled = !1),
        (this.variantIdField.value = i.id))
      : (this.variantIdField.disabled = !0),
      this.onVariantSelected(i, this, e),
      null != this.historyState &&
        this.historyState.onVariantChange(i, this, e);
  }),
  (window.Shopify.OptionSelectorsFromDOM = function (t, e) {
    var o = e.optionNames || [],
      i = e.priceFieldExists || !0,
      r = e.delimiter || "/",
      n = this.createProductFromSelector(t, o, i, r);
    (e.product = n),
      window.Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e);
  }),
  window.Shopify.extend(
    window.Shopify.OptionSelectorsFromDOM,
    window.Shopify.OptionSelectors
  ),
  (window.Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector =
    function (t, e, o, i) {
      if (!window.Shopify.isDefined(o)) var o = !0;
      if (!window.Shopify.isDefined(i)) var i = "/";
      var r = document.getElementById(t),
        n = r.childNodes,
        a = (r.parentNode, e.length),
        s = [];
      window.Shopify.each(n, function (t, r) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
          var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
          0 == e.length && (a = n.length - (o ? 1 : 0));
          var p = n.slice(0, a),
            l = o ? n[a] : "",
            c =
              (t.getAttribute("value"),
              {
                available: t.disabled ? !1 : !0,
                id: parseFloat(t.value),
                price: l,
                option1: p[0],
                option2: p[1],
                option3: p[2],
              });
          s.push(c);
        }
      });
      var p = { variants: s };
      if (0 == e.length) {
        p.options = [];
        for (var l = 0; a > l; l++) p.options[l] = "option " + (l + 1);
      } else p.options = e;
      return p;
    }),
  (window.Shopify.SingleOptionSelector = function (t, e, o, i) {
    (this.multiSelector = t),
      (this.values = i),
      (this.index = e),
      (this.name = o),
      (this.element = document.createElement("select"));
    for (var r = 0; r < i.length; r++) {
      var n = document.createElement("option");
      (n.value = i[r]), (n.innerHTML = i[r]), this.element.appendChild(n);
    }
    return (
      this.element.setAttribute("class", this.multiSelector.selectorClass),
      this.element.setAttribute("data-option", "option" + (e + 1)),
      (this.element.id = t.domIdPrefix + "-option-" + e),
      (this.element.onchange = function (o, i) {
        (i = i || {}), t.updateSelectors(e, i);
      }),
      !0
    );
  }),
  (window.Shopify.Image = {
    preload: function (t, e) {
      for (var o = 0; o < t.length; o++) {
        var i = t[o];
        this.loadImage(this.getSizedImageUrl(i, e));
      }
    },
    loadImage: function (t) {
      new Image().src = t;
    },
    switchImage: function (t, e, o) {
      if (t && e) {
        var i = this.imageSize(e.src),
          r = this.getSizedImageUrl(t.src, i);
        o ? o(r, t, e) : (e.src = r);
      }
    },
    imageSize: function (t) {
      var e = t.match(
        /_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./
      );
      return null != e ? e[1] : null;
    },
    getSizedImageUrl: function (t, e) {
      if (null == e) return t;
      if ("master" == e) return this.removeProtocol(t);
      var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (null != o) {
        var i = t.split(o[0]),
          r = o[0];
        return this.removeProtocol(i[0] + "_" + e + r);
      }
      return null;
    },
    removeProtocol: function (t) {
      return t.replace(/http(s)?:/, "");
    },
  }),
  (window.Shopify.OptionSelectors.HistoryState = function (t) {
    this.browserSupports() && this.register(t);
  }),
  (window.Shopify.OptionSelectors.HistoryState.prototype.register = function (
    t
  ) {
    window.addEventListener("popstate", function (e) {
      t.selectVariantFromParamsOrDropdown({ popStateCall: !0 });
    });
  }),
  (window.Shopify.OptionSelectors.HistoryState.prototype.onVariantChange =
    function (t, e, o) {
      this.browserSupports() &&
        (!t ||
          o.initialLoad ||
          o.popStateCall ||
          window.Shopify.setParam("variant", t.id));
    }),
  (window.Shopify.OptionSelectors.HistoryState.prototype.browserSupports =
    function () {
      return window.history && window.history.replaceState;
    });

$(document).on("shopify:block:select", function (e) {
  var blockId = e.detail.blockId;
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if (
    $parentSection.hasClass("shopify-section--slideshow") ||
    $parentSection.hasClass("shopify-section--testimonials")
  ) {
    sliderBlock.select(blockId, $parentSection);
  }
});

$(document).on("shopify:block:deselect", function (e) {
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if (
    $parentSection.hasClass("shopify-section--slideshow") ||
    $parentSection.hasClass("shopify-section--testimonials")
  ) {
    window.sliderBlock.deselect($parentSection);
  }
});

$(document).on("shopify:section:reorder", function (e) {
  window.utils.initializeSectionWrapper();
});

$(document).on("shopify:section:load", function (e) {
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  window.utils.initializeSectionWrapper();
  window.utils.enableDisclosure();

  if (window.PXUTheme.theme_settings.enable_autocomplete) {
    window.searchAutocomplete.init();
  }

  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }

  if ($parentSection.hasClass("shopify-section--article-template")) {
    window.sidebarAccordions.init();
  }

  if ($parentSection.hasClass("shopify-section--blog-template")) {
    window.sidebarAccordions.init();
  }

  if ($parentSection.hasClass("shopify-section--product-sidebar")) {
    window.sidebarAccordions.init();
  }

  if ($parentSection.hasClass("shopify-section--page-gallery-template")) {
    window.gallery.init($parentSection);
  }

  if ($parentSection.hasClass("shopify-section--gallery")) {
    window.gallery.init();
  }

  if (
    $parentSection.hasClass("shopify-section--page-faq-template") ||
    $parentSection.hasClass("shopify-section--faq")
  ) {
    window.accordion.init();
  }

  if ($parentSection.hasClass("shopify-section--cart-template")) {
    window.cart.init();
    if (typeof window.initCartCheckoutCountdown === "function") {
      window.initCartCheckoutCountdown();
    }
  }

  if ($parentSection.hasClass("shopify-section--cart-drawer")) {
    window.cart.init();
    window.utils.initializeSectionWrapper();
    if (typeof window.initCartCheckoutCountdown === "function") {
      window.initCartCheckoutCountdown();
    }
  }

  if ($parentSection.hasClass("shopify-section--featured-promotions")) {
    window.featuredPromotions.init();
  }

  if ($parentSection.hasClass("shopify-section--slideshow")) {
    window.slideshow.init();
  }

  if ($parentSection.hasClass("shopify-section--testimonials")) {
    window.testimonials.init();
  }

  if ($parentSection.hasClass("shopify-section--featured-product")) {
    window.productPage.init();
    window.productPage.runOptionSelector($parentSection);
    window.videoFeature.init();
    window.productPage.productSwatches();
  }

  if ($parentSection.hasClass("shopify-section--map")) {
    window.map.init();
  }

  if ($parentSection.hasClass("shopify-section--featured-collection")) {
    window.featuredCollection.init();
    window.productPage.init();
    window.productPage.runOptionSelector($parentSection);
    window.videoFeature.init();
  }

  if ($parentSection.hasClass("shopify-section--video")) {
    window.video.init();
  }

  if (
    $parentSection.hasClass("shopify-section--product-template") ||
    $parentSection.hasClass("shopify-section--quick-shop")
  ) {
    window.productPage.init();
    window.productPage.runOptionSelector($parentSection);
    window.videoFeature.init();
    window.productPage.productSwatches();
    window.recentlyViewed.init();
  }

  if ($parentSection.hasClass("shopify-section--recommended-products")) {
    window.productPage.init();
  }

  if ($parentSection.hasClass("shopify-section--recently-viewed-products")) {
    window.recentlyViewed.init();
  }

  if ($parentSection.hasClass("shopify-section--article-template")) {
    if (window.location.pathname.indexOf("/comments") != -1) {
      $("html,body").animate(
        { scrollTop: $("#new-comment").offset().top - 140 },
        "slow"
      );
    }
  }

  if ($parentSection.hasClass("shopify-section--collection-template")) {
    window.collectionSidebarFilter.init();
    window.productPage.init();
    window.productPage.runOptionSelector($parentSection);
    window.sidebarAccordions.init();
    window.recentlyViewed.init();
  }

  if ($parentSection.hasClass("shopify-section--contact-section")) {
    window.map.init();
  }

  if ($parentSection.hasClass("shopify-section--search-template")) {
    if (window.PXUTheme.theme_settings.enable_autocomplete) {
      window.searchAutocomplete.init();
    }
    window.collectionSidebarFilter.init();
    window.sidebarAccordions.init();
  }

  if ($parentSection.hasClass("shopify-section--header")) {
    window.meganavManager.injectAll();
    window.header.init();
  }

  if ($parentSection.hasClass("shopify-section--mega-menu")) {
    window.meganavManager.add($parentSection[0]);
  }
});

$(document).on("shopify:section:unload", function (e) {
  var $target = $(e.target);
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if ($parentSection.hasClass("shopify-section--header")) {
    window.header.unload($target);
  }

  if ($parentSection.hasClass("shopify-section--slideshow")) {
    window.slideshow.unload($target);
  }

  if ($parentSection.hasClass("shopify-section--testimonials")) {
    window.testimonials.unload($target);
  }

  if ($parentSection.hasClass("shopify-section--search")) {
    window.searchAutocomplete.unload($target);
  }

  if ($parentSection.hasClass("shopify-section--product-template")) {
    window.productPage.unload($parentSection);
  }

  if ($parentSection.hasClass("shopify-section--featured-product")) {
    window.productPage.unload($parentSection);
  }

  if ($parentSection.hasClass("shopify-section--mega-menu")) {
    window.meganavManager.remove($parentSection[0]);
  }

  // When sections are removed from the DOM, reinitialize the section wrapper
  window.requestAnimationFrame(() => {
    window.utils.initializeSectionWrapper();
  });
});

$(document).on("shopify:section:select", function (e) {
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if ($parentSection.hasClass("shopify-section--mega-menu")) {
    window.meganavManager.select($parentSection[0]);
  }

  if ($parentSection.hasClass("shopify-section--featured-collection")) {
    window.featuredCollection.unload($parentSection);
    window.featuredCollection.init();
  }

  var evt = document.createEvent("UIEvents");
  evt.initUIEvent("resize", true, false, window, 0);
  window.dispatchEvent(evt);
});

$(document).on("shopify:section:deselect", function (e) {
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if ($parentSection.hasClass("shopify-section--mega-menu")) {
    window.meganavManager.deselect();
  }
});

function setModalValues(modalId, image) {
  const section = document.querySelector("#cart-template");
  section.dataset.modalId = modalId;
  section.dataset.modalImage = image;
}
